// Values of the "Project Type" selector shown for QAQC events; not the persisted Server.QAQCType
export enum QaqcProjectType {
  Milestone = 'milestone',
  WorkOrder = 'workOrder',
}
